import { render, staticRenderFns } from "./create.vue?vue&type=template&id=41b3229c&scoped=true&"
import script from "./create.vue?vue&type=script&lang=js&"
export * from "./create.vue?vue&type=script&lang=js&"
import style0 from "./create.vue?vue&type=style&index=0&id=41b3229c&scoped=true&lang=css&"
import style1 from "./create.vue?vue&type=style&index=1&id=41b3229c&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b3229c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41b3229c')) {
      api.createRecord('41b3229c', component.options)
    } else {
      api.reload('41b3229c', component.options)
    }
    module.hot.accept("./create.vue?vue&type=template&id=41b3229c&scoped=true&", function () {
      api.rerender('41b3229c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/components/create.vue"
export default component.exports